import { defineInvokeEventa } from "./node_modules/.pnpm/@moeru_eventa@1.0.0-beta.4_electron@41.2.1_h3@2.0.1-rc.20_crossws@0.4.5_srvx@0.11.15__/node_modules/@moeru/eventa/dist/src-CTs6h4Ci.js";
//#region src/index.ts
const screenCaptureGetSources = defineInvokeEventa("eventa:invoke:electron:screen-capture:get-sources");
const screenCaptureSetSourceEx = defineInvokeEventa("eventa:invoke:electron:screen-capture:set-source");
const screenCaptureResetSource = defineInvokeEventa("eventa:invoke:electron:screen-capture:reset-source");
const screenCaptureCheckMacOSPermission = defineInvokeEventa("eventa:invoke:electron:screen-capture:check-macos-permission");
const screenCaptureRequestMacOSPermission = defineInvokeEventa("eventa:invoke:electron:screen-capture:request-macos-permission");
const screenCapture = {
	getSources: screenCaptureGetSources,
	setSource: screenCaptureSetSourceEx,
	resetSource: screenCaptureResetSource,
	checkMacOSPermission: screenCaptureCheckMacOSPermission,
	requestMacOSPermission: screenCaptureRequestMacOSPermission
};
//#endregion
export { screenCapture, screenCaptureCheckMacOSPermission, screenCaptureGetSources, screenCaptureRequestMacOSPermission, screenCaptureResetSource, screenCaptureSetSourceEx };
